class News {
    constructor(tabs, panels, activatingClass = 'is-active') {
        this.tabs = document.querySelectorAll(tabs);
        this.panels = document.querySelectorAll(panels);
        this.activatingClass = activatingClass;

        if(this.tabs.length) {
            this.events();
        }
    }

    // ============
    // Events
    // =============
    events() {
        this.tabs.forEach(tab => tab.addEventListener('click', (event) => this.handleTabClick(event.target)))
    }

    // ============
    // Methods
    // =============

    // タブクリックの処理
    handleTabClick(tab) {
        this.activateTab(tab);
        this.changePanel(tab);
    }

    // アクティブのタブのスタイルの処理
    activateTab(tab) {
        this.tabs.forEach(otherTab => {
            if(otherTab.dataset.categoryTab !== tab.dataset.categoryTab) {
                otherTab.classList.remove(this.activatingClass)
            }else {
                otherTab.classList.add(this.activatingClass)
            }
        });
    }

    // パネルの表示/非表示
    changePanel(tab) {
        this.panels.forEach(panel => {
            if(panel.dataset.categoryPanal === tab.dataset.categoryTab ) {
                panel.style.display = '';
            }else {
                panel.style.display = 'none';
            }
        })
    }
}

export default News;